import { Panel } from "@/components/atoms/Panel";
import {
  PrivacyPolicyLinkForm,
  PrivacyPolicyTreatmentLinkForm,
  SpecialTermsLinkForm,
  TermsOfUseLinkForm,
} from "@/components/atoms/TermsLink";
import React, { ReactNode } from "react";
import { Font, color } from "@moneyforward/mfx_biz_react_components";
import { FormCheckBox, FormErrorMessage } from "@/components/molecules";
import { termsValidation } from "@/components/validations";
import config from "@/libs/config";

type Props = {
  termOfUse: string;
  specialTerm: string;
  privacyPolicy: string;
  adEmailDelivery: string;
  usingExternalIdp?: boolean; // 外部IDPを使用するかどうか
  usingBizsol?: boolean;
};

const termsFormField = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  // for backward compatibility until we can refactor all usages of this component
  // once refactoring is done, remove usingExternalIdp prop
  const usingBizsol =
    props.usingBizsol === undefined
      ? props.usingExternalIdp && config.USING_BIZSOL
      : props.usingBizsol;

  const adMailDeliveryTermBase = `${config.BANK_FORMAL_NAME}及びマネーフォワードエックス株式会社から、それぞれ、新サービス、キャンペーン等のお知らせメールを受けることに同意が必要です`;

  const extIDPServiceMessage = usingBizsol
    ? `${config.BIZSOL_DISPLAY_NAME}に登録されているメールアドレスへ`
    : // CONNECT-BIZ(旧CONNECT-BOARD) は、
      // 外部IDPに登録されているメールアドレスに送信するわけではないので、本文は表示しない
      "";

  const adMailDeliveryTerm = `${extIDPServiceMessage}${adMailDeliveryTermBase}`;

  const FormFieldFor = ({
    name,
    children,
  }: {
    name: string;
    children: ReactNode;
  }) => {
    return (
      <>
        <label css={{ display: "flex", gap: "4px", alignItems: "flex-start" }}>
          <FormCheckBox
            name={name}
            value="check"
            registerOptions={{
              validate: termsValidation,
            }}
            ref={ref}
          />
          {children}
        </label>
        <FormErrorMessage name={name} />
      </>
    );
  };

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        marginTop: "24px",
      }}
    >
      <Panel
        css={{
          display: "flex",
          flexDirection: "column",
          padding: "16px 24px",
          gap: "24px",
        }}
      >
        <Font variant="m" component="p">
          下記の規約に同意の上、登録ボタンをクリックし、お進みください。
        </Font>

        <FormFieldFor name={props.termOfUse}>
          <TermsOfUseLinkForm />
        </FormFieldFor>
        <FormFieldFor name={props.specialTerm}>
          <SpecialTermsLinkForm />
        </FormFieldFor>
        <FormFieldFor name={props.privacyPolicy}>
          <PrivacyPolicyTreatmentLinkForm />
        </FormFieldFor>
      </Panel>

      <Panel
        css={{
          display: "flex",
          flexDirection: "column",
          padding: "16px 24px",
          gap: "12px",
        }}
      >
        {adMailDeliveryTerm}
        <FormFieldFor name={props.adEmailDelivery}>同意する</FormFieldFor>
      </Panel>
    </div>
  );
};

export const TermsFormField = React.forwardRef(termsFormField);
